<template>
  <v-menu
    v-if="podeAcessarAutorizacoes"
    :close-on-content-click="false"
    :nudge-width="100"
    offset-x
  >
    <template v-slot:activator="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click="pushAutorizacoes()"
        style="box-shadow: none"
        class="text-none"
        v-if="autorizacoesDados.length > 0"
        :content="autorizacoesDados.length"
        color="error"
      >
        <v-badge
          v-if="autorizacoesDados.length > 0"
          :content="autorizacoesDados.length"
          color="error"
        >
          <v-icon> fa fa-unlock-alt </v-icon>
        </v-badge>
      </v-btn>
      <v-btn v-else icon style="box-shadow: none" class="text-none" @click="pushAutorizacoes()">
        <v-icon aria-hidden="true">fa fa-bell</v-icon>
      </v-btn>
    </template>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ENotificacoesList",
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Autorizacoes", ["autorizacoes", "autorizacoesList"]),
    autorizacoesDados() {
      return this.autorizacoesList.filter((a) => a.status === "PENDENTE");
    },
    ehAprovador() {
      const role = this.user?.roleName;
      if (role === "super-admin") return true;
      return role === "admin" && !!this.usuarioTiId && this.user.id === this.usuarioTiId;
    },
    podeAcessarAutorizacoes() {
      return this.ehAprovador || ["professor", "prof-auxiliar"].includes(this.user?.roleName);
    },
  },
  data() {
    return {
      usuarioTiId: null,
    };
  },
  async mounted() {
    const role = this.user?.roleName;
    if (!["admin", "sguper-admin", "professor", "prof-auxiliar"].includes(role)) return;

    if (role === "admin") {
      await this.carregarUsuarioTi();
    }

    if (!this.podeAcessarAutorizacoes) return;

    this.loadPedidos();
    this.pollingInterval = setInterval(() => {
      if (this.$route.name === "autorizacoes") return;
      this.loadAutorizacoes();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.pollingInterval);
  },
  methods: {
    ...mapActions("Autorizacoes", ["loadAutorizacoes"]),

    async carregarUsuarioTi() {
      try {
        const response = await this.$services.autorizacoesService.getUsuarioTi();
        this.usuarioTiId = response.data?.id ?? null;
      } catch (error) {
        this.usuarioTiId = null;
      }
    },

    async loadPedidos() {
      try {
        this.$loaderService.open("Carregando dados");
        await this.loadAutorizacoes();
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    pushAutorizacoes() {
      this.$router.push({ name: "autorizacoes" });
    },
  },
};
</script>

<style scoped>
.notifications-list {
  max-height: 400px;
  overflow-y: hidden;
}
.notifications-list:hover {
  overflow-y: auto;
}
</style>
